import React, { useEffect, useCallback, useState} from 'react';
import {formatDate} from "components/selector2/formatDate.js"
import {truncate} from './AudioPlayer.js';
import {connect} from 'react-redux';
import {getBlockDate} from 'utils/getBlockDate.js';

const CLOSER = 60*48*60*1000;
const CLOSER_MIN = 60*60*1000;
const _formatDate = (date) => {
    let dist = new Date().getTime() - date.getTime() 
    console.log("distance = ", dist);
    if (dist < CLOSER_MIN) {
        return `${Math.round(dist / 1000 / 60 )} min. ago`;
    } else if (dist < CLOSER) {
        return `${Math.round(dist / 1000 / 60 / 60)} hours ago`;
    }
    return formatDate(date);
};

const SporeItem = ({spore, isSelected, setSelected}) => { 
    let [date, setDate] = useState();
    useEffect(() => {
        getBlockDate(spore.blockNumber).then(setDate);
    }, [spore]);
    return (
        <div
          onClick={() => setSelected(spore)}
          className={isSelected ? "spore-item selected" : "spore-item"}>
          <div className="spore-id">
            Spore #{spore.sporeId}
          </div>
          <div className="hyphen"/>
          <div className="spore-creator">
            {truncate(spore.creator)}
          </div>
          <div className="spore-date">
            {date && _formatDate(date)}
          </div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SporeItem);
